<template>
    <div class="site-section block-15  beige-backgound">
        <div class="container">
            <div v-if="this.terms != null" class="row" style="margin-right:0;margin-left:0">
                <div class="col-md-6 mx-auto text-center mb-5 section-heading">
                    <h2 class="mb-5 bannerFont">{{$t('Terminos["Titulo"]')}}</h2>
                </div>
            </div>
            <div class="site-section site-section-sm">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 offset-md-2 " v-if="this.terms != null">
                            <div v-show="this.$i18n.locale == 'en'">
                                <p style="font-size: 16px; font-weight: 400;" v-html="terms.idiomasDelSistemaTambo.ingles"></p>
                            </div>  
                            <div v-show="this.$i18n.locale != 'en'">
                                <p style="font-size: 16px; font-weight: 400;" v-html="terms.idiomasDelSistemaTambo.espaniol"></p>                                
                            </div>              
                        </div>
                    </div>
                </div>
            </div>
        </div>       
    </div>
</template>

<script>

import { db } from '@/firebase.js'

export default {
    name: "Promociones",    
    data () {
      return {
        terms: []
      }
    },
    methods:{
        async getTerms() {
           try {
                this.terms = (
                    await db
                    .child("terminos")
                    .once("value")
                ).val()
            } catch (ex) {
                return console.error(ex)
            }            
        },
    },    
    async mounted() {
        //console.log(this.sliders)
        await this.getTerms()         
    }
}
</script>

<style scoped>
    .price{
        background-color: rgb(167, 91, 31);
        padding-top: 20px;
        padding-bottom: 20px;
        color: white;
        font-size: 20px;
        font-weight: bolder;
        margin-left: 30%;
        margin-right: 30%;
        border-radius: 20px;
    }
    .container{
        width:100% !important;
        margin:0 !important;
        padding:0 !important;
    }
    .img-fluid{
        height: 80vh;
        width: 100%;
    }
    .promocionesTambo{
        width: 100% !important;
        /*height: 60vh;*/
        text-align:left;
        position:relative;
    }   
    .vertical-align {
        display: table-cell;
        vertical-align: middle;
    }
    .onTop {
        position: relative;
        z-index: 99;
    }
    .innerContainer {
        height: 100%;
        border-radius: 7%;
        background-color: rgba(252, 252, 252,.8);
        padding-right:20px;
        padding-bottom:20px;
        padding-top:20px;
        padding-left:10px;
        width: 30%;
        margin: 0;
        position: absolute;
        top: 50%;
        left: 20%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 99;
    }
    .terminos{
        font-size: 10px !important;
    }
    .innerContainerBottom {
        height: 15%;
        background-color: rgb(252, 252, 252);
        padding-right:20px;
        padding-bottom:20px;
        padding-top:20px;
        padding-left:10px;
        width: 100%;
        margin: 0;
        position: absolute;
        bottom: -10%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        z-index: 99;
    }
    .tituloPromocion{
        padding-top:10px;
        font-size: 19px;
        color: rgb(167,91,31) !important;
    }   
    .infoPromocion{
        font-size: 16px;
    } 
    .Carousel {
        height: 100vh !important;
        position: relative !important;
        margin: 0 !important;
    }
    @media (min-width: 1200px){
    
        .container {
            max-width: 99%;
            margin:0 !important;
            padding:0 !important;
        }   
    }   @media (min-width: 768px){
        .container {
            max-width: 99%;
            margin:0 !important;
            padding:0 !important;
        }
        .infoPromocion{
            padding-top:10px;
            font-size: 14px ;
        }
    }
    @media (min-width: 576px){
        .container {
            max-width: 99%;
            margin:0 !important;
            padding:0 !important;
        }
    }
    @media only screen and (max-width: 500px) {
        .copyright{  
            background-color: rgba(88, 172, 225, 1)
        }
        .infoPromocion{
            padding-top:10px;
            font-size: 12px ;
        }
        .innerContainerBottom {
            height: 17%;            
        }
        .terminos{
            font-size: 8px !important;
            color: black;
        }
    }
    @media only screen and (max-width: 900px) {
        .innerContainer {
            border-radius: 7%;
            width: 50%;
            margin: 0;
            top: 50%;
            left: 30%;
            -ms-transform: translate(-50%, -50%);
            transform: translate(-50%, -50%);
        } 
        .price{
            font-size:16px;
        }
        .innerContainer h5{
            font-size:11px;
        }   
        .tituloPromocion, .infoPromocion{
            padding-top:10px;
            font-size: 16px ;
        }
        .terminos{
            font-size: 10px !important;
        }
    }

</style>



// WEBPACK FOOTER //
// TerminosCondiciones.vue?2532c3c3